import { render, staticRenderFns } from "./campaignAnnouncement.vue?vue&type=template&id=05c1b477&scoped=true&"
import script from "./campaignAnnouncement.vue?vue&type=script&lang=js&"
export * from "./campaignAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./campaignAnnouncement.vue?vue&type=style&index=0&id=05c1b477&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1b477",
  null
  
)

export default component.exports